export interface AuthAppConfig {
  key: string;
  name: string;
  domain: string;
}

export const APPROVED_APPS: Record<string, AuthAppConfig> = {
  cc: {
    key: 'cc',
    name: 'Compassion Causes',
    domain: 'compassioncauses.com',
  },
};
